function getRequestAnimationFrame () {
  if (typeof window === 'undefined') {
    return function (callback) { return callback(); }
  }

  var polyfill = function (callback) {
    return setTimeout(callback, 16)
  }

  return window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    polyfill
}

function getCancelAnimationFrame () {
  if (typeof window === 'undefined') {
    return function () {}
  }
  return window.cancelAnimationFrame ||
    window.mozCancelAnimationFrame ||
    clearTimeout || (function () {})
}

module.exports = function raf (fn) {
  var requestAnimationFrame = getRequestAnimationFrame()
  var cancelAnimationFrame = getCancelAnimationFrame()

  var requested = false
  var reqId

  return function rafed () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (!requested) {
      requested = true
      reqId = requestAnimationFrame(function () {
        if (requested) {
          requested = false
          fn.apply(void 0, args)
        }
      })
    }

    return function cancel () {
      cancelAnimationFrame(reqId)
      requested = false
    }
  }
}
